const UPLOAD_USER_IMAGE_API = '/usermedialibrary/upload';

interface UploadImageResponse {
  status: 'ok' | 'fail';
  file_id?: string;
  file_name?: string;
  height?: number;
  width?: number;
  original_data?: boolean;
  original_name?: string;
  msg: string;
}

export const uploadImage = async (imageFile: File) => {
  const formData = new FormData();
  formData.append('upload_filename', imageFile);
  const response = await fetch(UPLOAD_USER_IMAGE_API, {
    body: formData,
    method: 'post',
  });

  const json = (await response.json()) as UploadImageResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.msg ?? 'Unknown error');
  return json;
};
